export const MULTISOURCE_FEATURE_FLAG_NAME = "multisource" as const
